/**
 * Yüklenecek dosyanın gerçek boyutu (9.1.6 · D-566).
 *
 * Ses kaydı hiçbir boyut taşımıyor: kayıt cihazı yalnız bir `uri` veriyor.
 * `sendVoice` buraya `0` yazıyordu ve sunucu pozitif olmayan boyutu reddettiği
 * için ses mesajı HİÇ gönderilemiyordu. Seçiciden gelen videoda da aynı tuzak
 * gizliydi: `asset.fileSize` yoksa oraya da `0` düşüyordu.
 *
 * `expo-file-system` ikilide zaten var — `services/api.ts` yüklemeyi onunla
 * yapıyor — ama yine de korumalı isteniyor: eski bir ikili bu modülü
 * taşımıyorsa ekranın tamamı çökmemeli.
 */
export function readFileSizeBytes(uri: string): number {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { File } = require('expo-file-system') as { File: new (uri: string) => { size?: number | null } };
    const boyut = new File(uri).size;
    return typeof boyut === 'number' && Number.isFinite(boyut) && boyut > 0 ? boyut : 0;
  } catch {
    return 0;
  }
}
